module.exports = __webpack_public_path__ + "/bundle/asset/admission5-22ac52f43674553acced3b65c7fc1dc5.png";